module.exports = __webpack_public_path__ + "img/img13.f3ed627a.svg";